import type { TranslationTree } from '../../locale.model';

export const pagesEsEs: TranslationTree = {
  manufacturers: {
    title: 'Fabricantes',
    subtitle: 'Gestione los fabricantes disponibles para el licenciamiento.',
    newButton: 'Nuevo fabricante',
    summaryAria: 'Resumen de fabricantes',
    registered: 'Registrados',
    searchPlaceholder: 'Buscar fabricantes...',
    loading: 'Cargando fabricantes...',
    empty: 'No se encontraron fabricantes.',
    table: {
      manufacturer: 'Fabricante',
      description: 'Descripción',
      createdAt: 'Creado el',
      actions: 'Acciones',
    },
    editAria: 'Editar fabricante',
    deleteAria: 'Eliminar fabricante',
    delete: {
      title: 'Confirmar eliminación',
      message: '¿Desea eliminar realmente el fabricante {{name}}?',
      cancel: 'Cancelar',
      confirm: 'Eliminar',
      deleting: 'Eliminando...',
    },
    form: {
      editTitle: 'Editar fabricante',
      createTitle: 'Nuevo fabricante',
      subtitle: 'Complete los datos para registrar o actualizar el fabricante.',
      name: 'Nombre',
      description: 'Descripción',
      cancel: 'Cancelar',
      saving: 'Guardando...',
      saveChanges: 'Guardar cambios',
      create: 'Crear fabricante',
    },
  },
  resellers: {
    title: 'Gestión de revendedores',
    subtitle: 'Registre y gestione sus revendedores asociados.',
    summaryAria: 'Resumen de revendedores',
    stats: {
      total: 'Total de revendedores',
      active: 'Revendedores activos',
      inactive: 'Revendedores inactivos',
      filtered: 'Filtrados',
    },
    searchPlaceholder: 'Buscar por código, nombre, correo o región...',
    statusFilter: {
      all: 'Todos',
      active: 'Activos',
      inactive: 'Inactivos',
    },
    commissionReport: 'Informe de comisiones',
    newButton: 'Nuevo revendedor',
    loading: 'Cargando revendedores...',
    empty: 'No se encontraron revendedores.',
    table: {
      code: 'Código',
      name: 'Nombre / Razón social',
      contact: 'Contacto',
      region: 'Región',
      clients: 'Clientes',
      status: 'Estado',
      inactiveAt: 'Fecha de inactivación',
      actions: 'Acciones',
    },
    clientsCount: '{{count}} cliente(s)',
    statusActive: 'Activo',
    statusInactive: 'Inactivo',
    moreActionsAria: 'Más acciones',
    edit: 'Editar',
    remove: 'Eliminar',
    report: {
      title: 'Informe de comisiones',
      subtitle: 'Informe de comisiones por revendedor basado en los clientes vinculados.',
      period: 'Periodo: mes actual',
      taxRate: 'Tasa (%):',
      baseTotal: 'Base total',
      commissionTotal: 'Total comisiones',
      averagePerReseller: 'Media por revendedor',
      table: {
        code: 'Código',
        reseller: 'Revendedor',
        clients: 'Clientes',
        baseValue: 'Valor base',
        tax: 'Tasa',
        commission: 'Comisión',
        status: 'Estado',
      },
      noData: 'No hay datos de comisión disponibles.',
      footer: '{{resellers}} revendedor(es) con {{clients}} cliente(s) en total.',
      close: 'Cerrar',
      exportPdf: 'Exportar PDF',
      statusPending: 'Pendiente',
    },
    form: {
      editTitle: 'Editar revendedor',
      createTitle: 'Nuevo revendedor',
      subtitle: 'Complete la información del revendedor.',
      code: 'Código',
      status: 'Estado',
      name: 'Nombre / Razón social',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      region: 'Región',
      cancel: 'Cancelar',
      saving: 'Guardando...',
      saveChanges: 'Guardar cambios',
      create: 'Registrar revendedor',
      errors: {
        phoneInvalid: 'Introduzca un teléfono válido o borre el campo.',
        required: 'Complete código, estado y nombre / razón social.',
      },
    },
    clientsModal: {
      title: 'Clientes de {{name}}',
      subtitle: 'Código: {{code}} - {{count}} cliente(s) vinculado(s)',
      searchPlaceholder: 'Buscar por empresa, CIF o nombre...',
      linked: 'Vinculados ({{count}})',
      available: 'Disponibles ({{count}})',
      loading: 'Cargando clientes vinculados...',
      noLinked: 'Ningún cliente vinculado',
      allLinked: 'Todos los clientes ya están vinculados',
      linking: 'Vinculando...',
      link: 'Vincular',
      close: 'Cerrar',
    },
    delete: {
      title: 'Confirmar eliminación',
      message: '¿Desea eliminar realmente el revendedor {{name}}?',
      cancel: 'Cancelar',
      confirm: 'Eliminar',
      deleting: 'Eliminando...',
    },
  },
  menus: {
    title: 'Menús',
    subtitle: 'Gestione los menús y submenús del sistema.',
    addMenu: 'Añadir menú',
    summaryAria: 'Resumen de menús',
    registered: 'Menús registrados',
    submenus: 'Submenús',
    searchPlaceholder: 'Buscar menús y submenús...',
    expandAll: 'Expandir todo',
    collapseAll: 'Contraer todo',
    loading: 'Cargando menús...',
    emptySearch: 'No se encontraron menús para la búsqueda.',
    empty: 'No hay menús registrados.',
    reorderHint:
      'Use ↑↓ o arrastre por ⋮⋮ para reordenar. El número a la izquierda refleja el orden guardado en la base de datos. Los menús solo pueden moverse dentro de la misma sección.',
    clearSearchToReorder: 'Borre la búsqueda para reordenar menús y submenús.',
    sectionInfo: 'Sección: {{section}} (order_section: {{orderSection}}) · {{count}} submenú(s)',
    sectionGroupAria: 'Sección {{section}}',
    sectionGroupMeta: '{{count}} menú(s) · order_section: {{orderSection}}',
    sectionGroupBadge: 'Sección',
    expandSectionAria: 'Expandir o contraer sección {{section}}',
    menuSubmenuCount: '{{count}} submenú(s)',
    moveUpMenu: 'Subir menú',
    moveDownMenu: 'Bajar menú',
    expandSubmenusAria: 'Expandir o contraer submenús de {{title}}',
    addSubmenu: '+ Submenú',
    editMenuAria: 'Editar menú',
    deleteMenuAria: 'Eliminar menú',
    dragMenuAria: 'Arrastrar menú',
    dragMenuTitle: 'Arrastrar para reordenar menú',
    noSubmenus: 'No hay submenús registrados.',
    marker: 'Marcador: {{bullet}}',
    moveUpSubmenu: 'Subir submenú',
    moveDownSubmenu: 'Bajar submenú',
    editSubmenuAria: 'Editar submenú',
    deleteSubmenuAria: 'Eliminar submenú',
    dragSubmenuAria: 'Arrastrar submenú',
    dragSubmenuTitle: 'Arrastrar para reordenar submenú',
    deleteMenu: {
      title: 'Eliminar menú',
      message: '¿Está seguro de que desea eliminar {{title}}? Se eliminarán todos los submenús.',
      cancel: 'Cancelar',
      confirm: 'Eliminar',
      deleting: 'Eliminando...',
    },
    deleteSubmenu: {
      title: 'Eliminar submenú',
      message: '¿Está seguro de que desea eliminar {{title}}? Esta acción no se puede deshacer.',
      cancel: 'Cancelar',
      confirm: 'Eliminar',
      deleting: 'Eliminando...',
    },
    menuForm: {
      editTitle: 'Editar menú',
      createTitle: 'Añadir menú',
      subtitle: 'Complete los datos del menú principal.',
      title: 'Título',
      path: 'Ruta',
      section: 'Sección',
      svg: 'SVG',
      saxIcon: 'Icono Sax',
      orderSection: 'Orden de la sección',
      orderHint: 'El orden del menú en la lista se define arrastrando en la pantalla principal.',
      cancel: 'Cancelar',
      saving: 'Guardando...',
      saveChanges: 'Guardar cambios',
      create: 'Crear menú',
    },
    submenuForm: {
      editTitle: 'Editar submenú',
      createTitle: 'Añadir submenú',
      subtitle: 'Complete los datos del submenú.',
      title: 'Título',
      path: 'Ruta',
      marker: 'Marcador',
      saxIcon: 'Icono Sax',
      cancel: 'Cancelar',
      saving: 'Guardando...',
      saveChanges: 'Guardar cambios',
      create: 'Crear submenú',
    },
    bullet: {
      bullet: 'Bullet (punto)',
      line: 'Line (línea)',
    },
  },
  ambience: {
    title: 'Ambiencia',
    subtitle: 'Gestione los elementos de ambientación y sus tipos para el sistema.',
    tabs: {
      items: 'Elementos de ambientación',
      types: 'Tipos de elementos',
    },
    addItem: 'Añadir elemento',
    addType: 'Añadir tipo de elemento',
    loadingItems: 'Cargando elementos...',
    emptyItems: 'No se encontraron elementos de ambientación.',
    loadingTypes: 'Cargando tipos...',
    emptyTypes: 'No se encontraron tipos de elemento.',
    table: {
      icon: 'Icono',
      name: 'Nombre',
      type: 'Tipo',
      description: 'Descripción',
      actions: 'Acciones',
    },
    editItemAria: 'Editar elemento',
    deleteItemAria: 'Eliminar elemento',
    editTypeAria: 'Editar tipo',
    deleteTypeAria: 'Eliminar tipo',
    typeForm: {
      editTitle: 'Editar tipo de elemento',
      createTitle: 'Añadir tipo de elemento',
      editHint: 'Actualice los datos del tipo de elemento de ambientación.',
      createHint: 'Añada un nuevo tipo de elemento de ambientación para su sistema.',
      name: 'Nombre',
      description: 'Descripción',
      saving: 'Guardando...',
      save: 'Guardar',
      cancel: 'Cancelar',
    },
    itemForm: {
      editTitle: 'Editar elemento',
      createTitle: 'Añadir elemento',
      editHint:
        'Actualice los datos del elemento de ambientación. El icono solo se sustituirá si se envía un archivo nuevo.',
      createHint: 'Añada un nuevo elemento de ambientación para su sistema.',
      iconPreviewAlt: 'Vista previa del icono',
      currentIconAlt: 'Icono actual',
      name: 'Nombre',
      itemType: 'Tipo de elemento',
      noTypeAvailable: 'Ningún tipo disponible',
      icon: 'Icono',
      iconOptional: ' (opcional)',
      keepCurrentIcon: 'Mantener icono actual',
      noFile: 'Ningún archivo seleccionado',
      browse: 'Examinar',
      saving: 'Guardando...',
      save: 'Guardar',
      cancel: 'Cancelar',
    },
    deleteType: {
      title: 'Confirmar eliminación',
      message: '¿Desea eliminar realmente el tipo {{name}}?',
      cancel: 'Cancelar',
      confirm: 'Eliminar',
      deleting: 'Eliminando...',
    },
    deleteItem: {
      title: 'Confirmar eliminación',
      message: '¿Desea eliminar realmente el elemento {{name}}?',
      cancel: 'Cancelar',
      confirm: 'Eliminar',
      deleting: 'Eliminando...',
    },
    feedback: {
      typeUpdated: 'Tipo actualizado',
      typeUpdatedMessage: 'El tipo "{{name}}" se actualizó correctamente.',
      typeCreated: 'Tipo creado',
      typeCreatedMessage: 'El tipo "{{name}}" se registró correctamente.',
      typeDeleted: 'Tipo eliminado',
      typeDeletedMessage: 'El tipo "{{name}}" se eliminó correctamente.',
      typeErrorCreate: 'Error al crear tipo',
      typeErrorUpdate: 'Error al actualizar tipo',
      typeErrorDelete: 'Error al eliminar tipo',
      itemUpdated: 'Elemento actualizado',
      itemUpdatedMessage: 'El elemento "{{name}}" se actualizó correctamente.',
      itemCreated: 'Elemento creado',
      itemCreatedMessage: 'El elemento "{{name}}" se registró correctamente.',
      itemDeleted: 'Elemento eliminado',
      itemDeletedMessage: 'El elemento "{{name}}" se eliminó correctamente.',
      itemErrorCreate: 'Error al crear elemento',
      itemErrorUpdate: 'Error al actualizar elemento',
      itemErrorDelete: 'Error al eliminar elemento',
      ok: 'OK',
    },
  },
  palettes: {
    list: {
      title: 'Patrones de color',
      newButton: 'Nuevo patrón de color',
      loading: 'Cargando paletas...',
      empty: 'No se encontraron paletas de color.',
      table: {
        name: 'Nombre',
        action: 'Acción',
      },
      editAria: 'Editar paleta',
      deleteAria: 'Eliminar paleta',
      delete: {
        title: 'Confirmar eliminación',
        message: '¿Desea eliminar realmente la paleta {{name}}?',
        cancel: 'Cancelar',
        confirm: 'Eliminar',
        deleting: 'Eliminando...',
      },
      feedback: {
        deleted: 'Paleta eliminada',
        deletedMessage: 'La paleta "{{name}}" se eliminó correctamente.',
        deleteError: 'Error al eliminar paleta',
        ok: 'OK',
      },
    },
    form: {
      editTitle: 'Editar patrón de color',
      createTitle: 'Nuevo patrón de color',
      loading: 'Cargando paleta...',
      nameLabel: 'Nombre del patrón',
      sections: {
        cardColors: 'Colores de la tarjeta',
        loginScreen: 'Pantalla de inicio de sesión',
        securityDashboard: 'Panel de seguridad',
        dashboard: 'Panel',
        verticalMenu: 'Menú vertical',
        horizontalMenu: 'Menú horizontal',
        priorities: 'Prioridades',
      },
      light: 'Claro',
      dark: 'Oscuro',
      card: 'Tarjeta',
      colorN: 'Color {{index}}',
      priorityLevel: 'priority.level_{{level}}',
      cancel: 'Cancelar',
      saving: 'Guardando...',
      save: 'Guardar',
      create: 'Crear',
      validation: 'Validación',
      nameRequired: 'Indique el nombre del patrón.',
      notFound: 'Paleta no encontrada.',
      backToList: 'Volver a patrones de color',
      feedback: {
        updated: 'Paleta actualizada',
        created: 'Paleta creada',
        successMessage: 'La paleta "{{name}}" se {{action}} correctamente.',
        errorCreate: 'Error al crear paleta',
        errorUpdate: 'Error al actualizar paleta',
        ok: 'OK',
      },
      fields: {
        background: 'Color de fondo',
        darkBackground: 'Color de fondo oscuro',
        accent: 'Color de acento',
        text: 'Color del texto',
        contrast: 'Color de contraste',
        iconAccent: 'Color de acento del icono',
        primary1: 'Color primario 1',
        primary2: 'Color primario 2',
        primary3: 'Color primario 3',
        primaryBlack1: 'Color primario negro 1',
        primaryBlack2: 'Color primario negro 2',
        primaryBlack3: 'Color primario negro 3',
        primaryLight1: 'Color primario claro 1',
        primaryLight2: 'Color primario claro 2',
        primaryLight3: 'Color primario claro 3',
        secondary1: 'Color secundario 1',
        secondary2: 'Color secundario 2',
        secondary3: 'Color secundario 3',
        secondary4: 'Color secundario 4',
        secondary5: 'Color secundario 5',
        secondary6: 'Color secundario 6',
        secondary7: 'Color secundario 7',
        secondary8: 'Color secundario 8',
        secondary9: 'Color secundario 9',
        secondary10: 'Color secundario 10',
      },
    },
  },
  clients: {
    title: 'Empresas',
    subtitle: 'Cree, edite o elimine empresas, con vinculación de vertical y fabricantes.',
    newButton: 'Nueva empresa',
    summaryAria: 'Resumen de empresas',
    registered: 'Registradas',
    searchPlaceholder: 'Buscar empresas...',
    filterInstallation: 'Instalación',
    filterStatus: 'Estado',
    filterAllInstallation: 'Todas',
    filterAllStatus: 'Todos',
    searchHint: 'La búsqueda por texto filtra solo los resultados de la página actual.',
    loading: 'Cargando empresas…',
    refreshing: 'Actualizando la lista…',
    empty: 'No se encontraron empresas.',
    table: {
      company: 'Empresa',
      vertical: 'Vertical',
      installation: 'Instalación',
      createdAt: 'Fecha de creación',
      status: 'Estado',
      actions: 'Acciones',
    },
    licensingAria: 'Resumen de licenciamiento',
    licensingTitle: 'Licenciamiento',
    editAria: 'Editar empresa',
    profilesAria: 'Gestionar perfiles',
    profilesTitle: 'Gestionar perfiles',
    usersAria: 'Gestionar usuarios',
    usersTitle: 'Gestionar usuarios',
    integrationsAria: 'Integraciones',
    integrationsTitle: 'Integraciones',
    deleteAria: 'Eliminar empresa',
    delete: {
      title: 'Confirmar eliminación',
      message: '¿Desea eliminar realmente la empresa {{name}}?',
      deleting: 'Eliminando la empresa…',
      cancel: 'Cancelar',
      confirm: 'Eliminar',
    },
    success: {
      created: 'Empresa creada',
      createdMessage: '{{name}} se registró correctamente. La lista se actualizó.',
      deleted: 'Empresa eliminada',
      deletedMessage: 'La empresa {{name}} se eliminó correctamente. La lista se actualizó.',
      updated: 'Empresa actualizada',
      updatedMessage: 'Los cambios en {{name}} se guardaron correctamente. La lista se actualizó.',
      ok: 'OK',
    },
    editModal: {
      savingCreate: 'Creando la empresa…',
      savingEdit: 'Guardando cambios…',
      sectionsAria: 'Secciones de la empresa',
      tabs: {
        info: 'Información general',
        config: 'Configuración',
        logos: 'Logotipos',
        ambientacao: 'Ambientación',
        analiticos: 'Analíticos',
        modulos: 'Módulos',
        licenca: 'Licencia',
      },
      vertical: 'Vertical',
      name: 'Nombre',
      legalName: 'Razón social',
      document: 'Documento',
      status: 'Estado',
      installationType: 'Tipo de instalación',
      subdomain: 'Subdominio',
      subdomainLocked: 'El subdominio no se puede cambiar.',
      subdomainLockedTitle: 'El subdominio no se puede cambiar tras la creación de la empresa',
      manufacturers: 'Fabricantes habilitados para la empresa',
      noManufacturers: 'No se cargaron fabricantes.',
      logo: 'Logotipo',
      noPreview: 'Sin vista previa',
      logoUploadHint:
        'La carga del logotipo se realiza en un paso separado en /company/:id/logo tras guardar la empresa.',
      select: 'Seleccione',
      active: 'Activo',
      inactive: 'Inactivo',
      legacyV1: 'v1 es modo heredado.',
      cancel: 'Cancelar',
      saving: 'Guardando…',
      saveChanges: 'Guardar cambios',
      create: 'Crear empresa',
      cancelConfirmTitle: '¿Descartar cambios?',
      errors: {
        waitSettings: 'Espere a que termine la carga de la configuración.',
        settingsNotLoaded:
          'La configuración aún no se ha cargado. Abra la pestaña «Configuración» y espere a que termine la carga.',
        requiredCreate: 'Complete vertical, nombre, razón social, documento y subdominio.',
        requiredEdit: 'Complete vertical, nombre, razón social y documento.',
        noStatus:
          'No hay estados disponibles. Verifique el endpoint de estados o los permisos de administrador.',
        invalidInstallation:
          'Seleccione un tipo de instalación válido (Cloud, On-premise o Híbrido).',
        moduleVersion: 'Seleccione la versión de gestión de módulos (v1 o v2).',
        logoUploadFailed: 'La empresa se guardó, pero falló la carga del logotipo: {{error}}',
        selectStatus: 'Seleccione el estado de la empresa.',
      },
      createTitle: 'Registro de nueva empresa',
      editTitle: 'Editar empresa',
      subtitle: 'Verifique si la empresa ya existe antes de continuar.',
      savingWait: 'Espere un momento, estamos comunicándonos con el servidor.',
      noStatusLoaded:
        'Ningún estado cargado. Se requiere GET /v1/licensing/companies/statuses (admin).',
      modulesVersion: 'Versión de gestión de módulos',
      legacyV1Hint:
        'Si utiliza este modo, toda la gestión de perfiles debe hacerse vía el módulo master de Fisitalview.',
      logoPreviewAlt: 'Vista previa del logotipo',
      loadingSettings: 'Cargando configuración…',
      sectionComingSoon: 'El contenido de esta sección se añadirá pronto.',
      cancelEditTitle: 'Cancelar edición',
      cancelEditMessage:
        '¿Está seguro de que desea cancelar? Los cambios no guardados se descartarán.',
      continueEditing: 'Continuar editando',
      confirmCancel: 'Sí, cancelar',
      tabsExtra: {
        cores: 'Colores personalizados',
        idioma: 'Idioma',
        localVisit: 'Local Visit',
        llms: 'LLMs',
      },
    },
    backToCompanies: 'Volver a empresas',
    companyFallback: 'Empresa',
    editTitle: 'Editar',
    errors: {
      companyNotIdentified: 'Empresa no identificada.',
      operationFailed: 'No fue posible completar la operación.',
      sessionExpired: 'Sesión inválida o expirada.',
    },
    workspace: {
      underConstruction: 'Área en construcción para la empresa',
    },
    routesAccess: {
      title: 'Módulos',
      description:
        'Defina qué categorías y módulos podrá ver esta empresa en el SaaS. Marcar la categoría habilita todos los módulos con ruta válida; puede habilitar módulos sueltos desmarcando elementos específicos.',
      expandAll: 'Expandir todo',
      collapseAll: 'Colapsar todo',
      loading: 'Cargando módulos y categorías…',
      empty: 'Ninguna categoría o módulo registrado.',
      emptyCategory: 'Ningún módulo en esta categoría.',
      incompleteRoute: 'Ruta incompleta en el catálogo',
      uncategorized: 'Sin categoría',
      errors: {
        waitLoading: 'Espere a que termine la carga de módulos.',
        notLoaded: 'Los módulos aún no se han cargado. Espere a que termine la carga.',
      },
    },
    ambientPermissions: {
      title: 'Elementos de ambientación habilitados',
      description:
        'Defina qué elementos de ambientación podrá utilizar esta empresa en el sistema. Marcar el tipo habilita todos los elementos de la categoría; puede habilitar elementos sueltos desmarcando elementos específicos.',
      loading: 'Cargando elementos de ambientación…',
      empty: 'Ningún tipo o elemento de ambientación registrado.',
      emptyType: 'Ningún elemento en este tipo.',
      errors: {
        waitLoading: 'Espere a que termine la carga de elementos de ambientación.',
        notLoaded:
          'Los elementos de ambientación aún no se han cargado. Espere a que termine la carga.',
      },
    },
    entitlements: {
      loading: 'Cargando entitlements…',
      description:
        'Licenciamiento server-side para clientes cloud/hybrid. Los cambios se aplican inmediatamente en fv-api cloud.',
      lastUpdated: 'Última actualización:',
      quotasTitle: 'Cuotas y vigencia',
      activeFrom: 'Activa desde (opcional)',
      expiresAt: 'Expira en (opcional)',
      locations: 'Locales',
      cameras: 'Cámaras',
      users: 'Usuarios',
      sensors: 'Sensores',
      storageGb: 'Almacenamiento (GB)',
      manufacturers: 'Fabricantes',
      saveSuccess: 'Entitlements guardados con éxito.',
      saveButton: 'Guardar entitlements',
      errors: {
        loadFailed: 'No fue posible cargar los entitlements.',
        saveFailed: 'Error al guardar entitlements. Verifique los datos.',
      },
    },
    licenseTab: {
      loading: 'Cargando licencia…',
      status: 'Estado:',
      validity: 'Vigencia',
      quotas: 'Cuotas',
      history: 'Historial',
      issuedAt: 'Emitida en',
      expiresAt: 'Expira en',
      download: 'Descargar',
      noLicense: 'Ninguna licencia emitida para este cliente.',
      generateTitle: 'Generar nueva licencia (.lic)',
      fingerprintHint:
        'Pegue el fingerprint generado en el servidor on-prem (`GET /license/fingerprint` o script CLI).',
      fingerprint: 'Fingerprint (64 hex)',
      generating: 'Generando…',
      generateButton: 'Generar y descargar .lic',
      errors: {
        loadFailed: 'No fue posible cargar los datos de la licencia.',
        fingerprintRequired: 'Indique el fingerprint de la máquina on-prem.',
        generateFailed:
          'Error al generar la licencia. Verifique los datos y la configuración cloud.',
        redownloadFailed: 'No se pudo descargar esta licencia de nuevo.',
      },
    },
    licensingOverview: {
      loading: 'Cargando datos…',
      entitlements: 'Entitlements',
      status: 'Estado:',
      noLicense: 'Ninguna licencia emitida.',
      analytics: 'Analíticos:',
      manufacturers: 'Fabricantes:',
      fingerprint: 'Fingerprint:',
      usageUsers: 'Usuarios registrados',
      usageLocations: 'Locales registrados',
      usageCameras: 'Cámaras registradas',
      usageSensors: 'Sensores registrados',
      usageStorage: 'Almacenamiento utilizado',
      onPremiseHint:
        'El consumo real (registros vs límites) solo está disponible para clientes cloud/hybrid. En on-premise, el uso se consulta en el servidor local del cliente.',
      errors: {
        loadFailed: 'No fue posible cargar los datos de licenciamiento.',
      },
    },
    profileEdit: {
      sectionsAria: 'Secciones del perfil',
      tabs: { general: 'General', routesModules: 'Rutas / Módulos' },
      warning:
        'Los cambios en este perfil afectan los accesos de todos los usuarios vinculados a él. Las rutas del perfil deben ser un subconjunto de las rutas habilitadas para la empresa.',
      warningUsers: 'todos los usuarios',
      nameLabel: 'Nombre del perfil',
      createTitle: 'Nuevo perfil',
      editTitle: 'Editar perfil',
      defaultName: 'Perfil',
      create: 'Crear perfil',
      errors: {
        nameRequired: 'Indique el nombre del perfil.',
        nameRequiredDetailsTab: 'Indique el nombre del perfil en la pestaña «Detalles».',
      },
    },
    profileRoutes: {
      helpTitle: 'Dónde configurar',
      helpText:
        'Abra Clientes → icono de perfil (escudo) → editar perfil → pestaña «Rutas / Módulos». Marque categorías/módulos; use ↑↓ o arrastre por ⋮⋮ a la derecha; complete «Nombre de sección» e «Icono en menú».',
      title: 'Rutas del perfil',
      subtitle: 'Subconjunto de las rutas habilitadas en la empresa.',
      empty:
        'Ninguna ruta habilitada para la empresa. Configure primero la pestaña Módulos en Editar empresa.',
      columns: {
        order: 'Orden',
        orderHint: 'Use ↑↓ para reordenar',
        category: 'Categoría',
        sectionName: 'Nombre de sección',
        actions: 'Acciones',
        module: 'Módulo',
        menuIcon: 'Icono en menú',
      },
      drag: {
        moveCategoryUp: 'Subir categoría',
        moveCategoryDown: 'Bajar categoría',
        moveModuleUp: 'Subir módulo',
        moveModuleDown: 'Bajar módulo',
        dragCategory: 'Arrastrar categoría',
        dragModule: 'Arrastrar módulo',
      },
      placeholders: {
        sectionName: 'Nombre en menú',
        checkCategory: 'Marque la categoría…',
        checkModule: 'Marque el módulo…',
      },
      errors: {
        waitLoading: 'Espere a que termine la carga de módulos.',
        profileNotIdentified: 'Perfil no identificado.',
      },
    },
    profilesPage: {
      title: 'Perfiles',
      registered: '{{count}} registrados',
      searchName: 'Nombre',
      search: 'Buscar',
      clearFiltersAria: 'Limpiar filtros',
      clear: 'Limpiar',
      newButton: '+ Nuevo perfil',
      filters: { all: 'Todos', active: 'Activos', inactive: 'Inactivos' },
      loading: 'Cargando perfiles…',
      empty: 'Ningún perfil encontrado.',
      editAria: 'Editar perfil',
      deleteAria: 'Eliminar perfil',
      toggleActiveAria: 'Perfil activo — clic para desactivar',
      toggleInactiveAria: 'Perfil inactivo — clic para activar',
      toggleActiveTitle: 'Activo — clic para desactivar',
      toggleInactiveTitle: 'Inactivo — clic para activar',
      delete: {
        title: 'Eliminar perfil',
        message:
          '¿Está seguro de que desea eliminar el perfil {{name}}? Esta acción no se puede deshacer.',
      },
    },
    usersPage: {
      title: 'Usuarios',
      subtitle: 'Gestionar usuarios de la empresa',
      refresh: 'Actualizar',
      addButton: 'Añadir',
      meta: {
        registered: '{{count}} registrado(s)',
        page: 'Página {{page}} de {{totalPages}} ({{limit}} por página)',
      },
      refreshing: 'Actualizando…',
      loading: 'Cargando usuarios…',
      master: 'Master',
      editAria: 'Editar usuario',
      deleteAria: 'Eliminar usuario',
      empty: {
        none: 'Ningún usuario registrado para esta empresa.',
        page: 'Ningún usuario en esta página.',
      },
      delete: {
        title: 'Eliminar usuario',
        message:
          '¿Está seguro de que desea eliminar al usuario {{name}}? Esta acción no se puede deshacer.',
      },
      errors: {
        notFound: 'Empresa o usuario no encontrado.',
        companyNotFound: 'Empresa no encontrada.',
        deleteDependencies: 'No fue posible eliminar el usuario (error al eliminar dependencias).',
        loadFailed: 'No fue posible cargar la lista de usuarios.',
        deleteFailed: 'No fue posible eliminar el usuario.',
        invalidPagination: 'Parámetros de paginación inválidos.',
        forbiddenList: 'Sin permiso para listar usuarios de esta empresa.',
        forbiddenDelete: 'Sin permiso para eliminar usuarios de esta empresa.',
      },
    },
    userEdit: {
      createTitle: 'Nuevo usuario',
      editTitle: 'Editar datos del usuario',
      fields: {
        firstName: 'Nombre',
        lastName: 'Apellido',
        email: 'Correo electrónico',
        userName: 'Nombre de usuario',
        phone: 'Teléfono',
        department: 'Departamento',
        profile: 'Perfil',
        language: 'Idioma',
        timezone: 'Zona horaria',
        currentProfile: 'Perfil actual',
      },
      blocked: 'Bloqueado',
      timezoneGroups: {
        utc: 'Desplazamiento UTC',
        iana: 'Zona horaria regional (IANA)',
      },
      resetting: 'Restableciendo…',
      resetPassword: 'Restablecer contraseña',
      create: 'Crear usuario',
      passwordDialog: {
        defaultTitle: 'Contraseña temporal',
        resetTitle: 'Contraseña restablecida',
        createTitle: 'Usuario creado',
        hint: 'Comparta esta contraseña temporal con el usuario. No se mostrará de nuevo.',
        copied: 'Contraseña copiada al portapapeles.',
        copyPassword: 'Copiar contraseña',
        copiedButton: 'Copiado',
        copy: 'Copiar',
        understood: 'Entendido',
      },
      errors: {
        phoneInvalid: 'Introduzca un teléfono válido o borre el campo.',
        profilesLoadFailed: 'No fue posible cargar los perfiles de la empresa.',
        resetFailed: 'No fue posible restablecer la contraseña.',
        requiredFields: 'Complete nombre, apellido, correo y nombre de usuario.',
        createFailed: 'No fue posible crear el usuario.',
        updateFailed: 'No fue posible actualizar el usuario.',
        licenseLimit: 'Límite de usuarios de la licencia alcanzado.',
        duplicate: 'El correo o nombre de usuario ya existen en esta empresa.',
        notFound: 'Empresa o usuario no encontrado.',
      },
    },
    integrations: {
      subtitle: 'SAFR y Lenel',
      safr: {
        loading: 'Cargando configuración SAFR…',
        autoSync: 'Sincronización automática con SAFR',
        authHint: 'El campo Autorización no se rellena automáticamente por seguridad.',
        paramsTitle: 'Parámetros SAFR',
        authPlaceholder: 'Indique la autorización para guardar',
        saveSuccess: 'Configuración SAFR guardada con éxito.',
        errors: { authRequired: 'Indique la autorización (no se muestra después de guardar).' },
      },
      lenel: {
        loading: 'Cargando configuración Lenel…',
        authInfo: 'Información de autenticación de la integración Lenel',
        passwordHint:
          'La contraseña no se muestra después de guardar. Indíquela de nuevo para cambiar.',
        enabled: 'Habilitado',
        saveSuccess: 'Configuración Lenel guardada.',
        errors: {
          passwordRequired: 'Indique la contraseña (nunca se muestra después de guardar).',
        },
      },
    },
  },
  operators: {
    title: 'Gestión de operadores',
    subtitle:
      'Gestione operadores asignados, horas de soporte, notas de servicio y partes de horas',
    summaryAria: 'Resumen',
    stats: {
      activeOperators: 'Operadores activos',
      allocatedHours: 'Horas asignadas',
      usedHours: '{{used}}h utilizadas ({{pct}}%)',
      pendingNotes: 'Notas pendientes',
      pendingApprovals: 'Aprobaciones pendientes',
    },
    tabs: {
      operators: 'Operadores',
      hours: 'Horas',
      notes: 'Notas',
      timesheet: 'Parte de horas',
      base: 'Base',
      profile: 'Mi perfil',
    },
    operadores: {
      searchPlaceholder: 'Buscar por nombre, correo o función...',
      newButton: 'Nuevo operador',
      filters: 'Filtros:',
      filterStatusAria: 'Filtrar por estado',
      allStatus: 'Todos los estados',
      filterClientAria: 'Filtrar por cliente',
      allClients: 'Todos los clientes',
      count: '{{displayed}} de {{total}} operadores',
      retry: 'Reintentar',
      loading: 'Cargando operadores…',
      empty: 'No hay operadores para mostrar.',
      table: {
        operator: 'Operador',
        role: 'Función',
        clients: 'Clientes',
        hours: 'Horas',
        status: 'Estado',
      },
      none: 'Ninguno',
      active: 'Activo',
      inactive: 'Inactivo',
      actionsAria: 'Acciones del operador',
      edit: 'Editar',
      remove: 'Eliminar',
      form: {
        editTitle: 'Editar operador',
        createTitle: 'Nuevo operador',
        subtitle: 'Complete la información del operador y los clientes vinculados (opcional).',
        closeAria: 'Cerrar',
        name: 'Nombre',
        email: 'Correo electrónico',
        role: 'Función',
        rolePlaceholder: 'Ej.: Soporte nivel 2',
        status: 'Estado',
        clientsSection: 'Clientes (companies)',
        clientsHint: 'Opcional. Sin selección equivale a ningún cliente.',
        noCompanies: 'No hay empresas listadas. Verifique GET /company y permisos.',
        cancel: 'Cancelar',
        saving: 'Guardando…',
        saveChanges: 'Guardar cambios',
        create: 'Crear operador',
        errorRequired: 'Complete nombre, correo electrónico y función.',
      },
    },
    horas: {
      title: 'Licenciamiento de horas de soporte e implantación',
      newPackage: 'Nuevo paquete de horas',
      retry: 'Reintentar',
      loading: 'Cargando paquetes de horas...',
      empty: 'No hay paquetes de horas registrados.',
      clientsCount: '{{count}} cliente(s)',
      available: 'Disponible: {{hours}}h',
      addHours: 'Añadir horas',
      total: 'Total',
      remaining: 'Quedan {{hours}}h disponibles',
      form: {
        createTitle: 'Nuevo paquete de horas',
        subtitle: 'Defina operador, horas totales y las companies con sus límites.',
        operator: 'Operador',
        select: 'Seleccione...',
        totalHours: 'Total de horas',
        companiesTitle: 'Companies del paquete',
        companiesHint: 'Añada una o más companies con maxHours.',
        addCompany: '+ Company',
        selectCompany: 'Seleccione company...',
        maxHours: 'maxHours',
        cancel: 'Cancelar',
        create: 'Crear paquete',
        saving: 'Guardando...',
      },
      addHoursModal: {
        title: 'Añadir horas',
        hours: 'Horas',
        cancel: 'Cancelar',
        confirm: 'Añadir',
      },
      errors: {
        packageRequired:
          'Seleccione operador, total de horas y al menos una company con carga válida.',
        duplicateCompany: 'No repita la misma company en el paquete.',
        hoursExceeded: 'La suma de horas por company no puede superar el total del paquete.',
        invalidHours: 'Indique una cantidad de horas válida.',
      },
    },
    notas: {
      title: 'Emisión de notas de servicio',
      newNote: 'Nueva nota de servicio',
      table: {
        number: 'Número',
        client: 'Cliente',
        operator: 'Operador',
        hours: 'Horas',
        value: 'Importe',
        date: 'Fecha',
        status: 'Estado',
      },
      status: {
        paid: 'Pagada',
        issued: 'Emitida',
        pending: 'Pendiente',
      },
      actionsAria: 'Acciones',
    },
    timesheet: {
      title: 'Parte de horas',
      newEntry: 'Nuevo registro',
      table: {
        date: 'Fecha',
        operator: 'Operador',
        client: 'Cliente',
        hours: 'Horas',
        description: 'Descripción',
        status: 'Estado',
      },
      status: {
        approved: 'Aprobado',
        pending: 'Pendiente',
      },
    },
    base: {
      title: 'Base de conocimiento',
      subtitle: 'Artículos de autoservicio con búsqueda semántica IA',
      refreshAria: 'Actualizar',
      listViewAria: 'Lista',
      gridViewAria: 'Cuadrícula',
      newArticle: 'Nuevo artículo',
      searchPlaceholder: 'Buscar artículos...',
      emptyArticles: 'Ningún artículo encontrado',
      createFirstArticle: 'Crear primer artículo',
      stats: {
        total: 'Total artículos',
        published: 'Publicados',
        views: 'Visualizaciones',
        helpful: 'Valoraciones útiles',
      },
      subTabs: {
        browse: 'Navegar',
        aiSearch: 'Búsqueda IA',
      },
    },
    perfil: {
      title: 'Mi perfil',
      tabs: {
        personal: 'Datos personales',
        preferences: 'Preferencias',
      },
      loadError: 'No se pudieron cargar sus datos. Actualice la página o inténtelo más tarde.',
      personalInfo: {
        title: 'Información personal',
        subtitle: 'Actualice su información de perfil y contacto',
        photoHint: 'Haga clic para cambiar la foto (máx. 2MB)',
        active: 'Activo',
        fullName: 'Nombre completo',
        email: 'Correo',
        timezonePlaceholder: 'Ej: UTC+03:00',
        saveError:
          'No se pudo guardar. Verifique el nombre de usuario y el tamaño de la imagen (máx. 2MB).',
        username: 'Nombre de usuario',
        emailLocked: 'El correo no se puede cambiar',
        phone: 'Teléfono',
        department: 'Departamento',
        language: 'Idioma',
        timezone: 'Zona horaria',
        saveSuccess: 'Datos actualizados correctamente.',
      },
      notifications: {
        title: 'Notificaciones',
        subtitle: 'Configure cómo desea recibir alertas',
        system: 'Notificaciones del sistema',
        systemHint: 'Recibir notificaciones de nuevos tickets',
        email: 'Notificaciones por correo',
        emailHint: 'Recibir resúmenes diarios por correo',
        sound: 'Alertas sonoras',
        soundHint: 'Reproducir sonido al recibir nuevos tickets',
      },
      appearance: {
        title: 'Apariencia',
        subtitle: 'Personalice la apariencia del sistema',
        darkMode: 'Modo oscuro',
        darkModeHint: 'Alternar entre tema claro y oscuro',
        compactView: 'Vista compacta',
        compactViewHint: 'Mostrar más tickets en pantalla',
        language: 'Idioma',
        languageHint: 'Seleccione el idioma del sistema',
      },
      workflow: {
        title: 'Flujo de trabajo',
        subtitle: 'Configure su comportamiento predeterminado',
        autoAssign: 'Autoasignación',
        autoAssignHint: 'Asignar automáticamente nuevos tickets de sus clientes',
      },
      saved: 'Guardado',
    },
  },
  param: {
    title: 'Parametrizaciones',
    subtitle: 'Configure parámetros, módulos y analíticos del sistema.',
    searchPlaceholder: 'Buscar verticales, módulos...',
    tabs: {
      verticals: 'Verticales',
      modules: 'Módulos',
      analytics: 'Analíticos',
    },
    verticals: {
      title: 'Verticales del sistema',
      newButton: '+ Nueva vertical',
      loading: 'Cargando verticales...',
      empty: 'No se encontraron verticales.',
      filterHint:
        'Haga clic en las tarjetas para filtrar qué verticales aparecen en la lista de módulos inferior. Puede seleccionar más de una.',
      selectAll: 'Marcar todas',
      deselectAll: 'Desmarcar todas',
      filterAria: 'Filtrar vertical {{name}}',
      deactivated: 'Desactivada',
      activeSummary: '{{active}}/{{total}} activos',
      selectVerticalHint: 'Seleccione una o más verticales arriba para ver los módulos asociados.',
      expandModulesAria: 'Expandir o contraer módulos de {{name}}',
      activateAll: 'Activar todos',
      deactivateAll: 'Desactivar todos',
      editAria: 'Editar vertical',
      deleteAria: 'Eliminar vertical',
      noModules: 'Ningún módulo asociado a esta vertical.',
      viewMarkdownAria: 'Ver markdown del módulo',
      form: {
        editTitle: 'Editar vertical',
        createTitle: 'Nueva vertical',
        subtitle: 'Indique nombre, descripción, color y estado de la vertical.',
        name: 'Nombre de la vertical',
        icon: 'Icono',
        description: 'Descripción',
        color: 'Color de la vertical (opcional)',
        colorHint: 'Si está vacío, se generará un color aleatorio.',
        status: 'Estado',
        active: 'Activa',
        inactive: 'Inactiva',
        associatedModules: 'Módulos asociados ({{count}} seleccionado(s))',
        noModulesAvailable: 'No hay módulos disponibles para asociar.',
        cancel: 'Cancelar',
        saving: 'Guardando...',
        saveChanges: 'Guardar cambios',
        create: 'Crear vertical',
        errors: {
          nameRequired: 'Indique nombre y descripción de la vertical.',
          invalidColor: 'Color no válido. Use #RGB o #RRGGBB.',
        },
      },
      delete: {
        title: 'Confirmar eliminación',
        message: '¿Desea eliminar realmente la vertical {{name}}?',
        cancel: 'Cancelar',
        confirm: 'Eliminar',
        deleting: 'Eliminando...',
      },
    },
    modules: {
      title: 'Módulos del sistema',
      expandAll: 'Expandir todo',
      collapseAll: 'Contraer todo',
      newCategory: '+ Nueva categoría',
      newModule: '+ Nuevo módulo',
      loading: 'Cargando módulos y categorías...',
      empty: 'No se encontraron módulos.',
      expandCategoryAria: 'Expandir o contraer categoría {{name}}',
      editCategoryAria: 'Editar categoría',
      enableModuleAria: 'Activar módulo',
      disableModuleAria: 'Desactivar módulo',
      viewDetailsAria: 'Ver detalles del módulo',
      editAria: 'Editar módulo',
      deleteAria: 'Eliminar módulo',
      noCategory: 'Sin categoría',
      view: {
        title: 'Detalles del módulo',
        subtitle: 'Vista completa de los datos del módulo (solo lectura).',
        loading: 'Cargando datos del módulo...',
        name: 'Nombre',
        category: 'Categoría',
        categoryPathPrefix: 'Prefijo de ruta (categoría)',
        modulePath: 'Segmento de ruta (módulo)',
        activationPath: 'Ruta de activación',
        activationPathMissing:
          'No definida: se requiere prefijo en la categoría y segmento de ruta en el módulo. El backend la compone automáticamente cuando ambos existen.',
        description: 'Descripción',
        markdown: 'Formación / Documentación (Markdown)',
        attachments: 'Adjuntos',
        noAttachments: 'No hay adjuntos disponibles.',
        close: 'Cerrar',
      },
      create: {
        title: 'Nuevo módulo',
        subtitle: 'Cree un nuevo módulo del sistema y asocie una categoría (opcional).',
        name: 'Nombre del módulo',
        description: 'Descripción',
        category: 'Categoría',
        noCategory: 'Sin categoría',
        pathSegment: 'Segmento de ruta (módulo)',
        pathHint: 'Un único segmento, sin "/" ni espacios. Opcional.',
        pathPlaceholder: 'ej.: reports',
        sectionName: 'Nombre de la sección (menú)',
        sectionPlaceholder: 'Por defecto: nombre de la categoría',
        menuIcon: 'Icono del menú',
        activationPreview: 'Vista previa de la ruta de activación',
        cancel: 'Cancelar',
        saving: 'Guardando...',
        create: 'Crear módulo',
        errors: {
          nameRequired: 'Indique el nombre del módulo.',
        },
      },
      edit: {
        title: 'Editar módulo',
        subtitle:
          'Actualice los datos del módulo y mantenga material de formación/documentación en markdown.',
        loading: 'Cargando datos completos del módulo...',
        pathHint:
          'Un único segmento, sin "/" ni espacios. Déjelo vacío para eliminar el segmento (PUT envía valor vacío como eliminación).',
        sectionName: 'Nombre de la sección (menú)',
        markdownTab: {
          write: 'Editar',
          preview: 'Vista previa',
        },
        attachments: {
          title: 'Adjuntos',
          uploading: 'Enviando...',
          add: '+ Añadir archivo',
          hint: 'Use attachment:id-del-adjunto en markdown, o haga clic en "Insertar en markdown".',
          empty: 'No se añadieron adjuntos.',
          pendingUpload: ' · pendiente de carga',
          insert: 'Insertar en markdown',
          removeAria: 'Eliminar adjunto',
          remote: 'Remoto',
          idLabel: 'ID',
        },
        cancel: 'Cancelar',
        saving: 'Guardando...',
        saveChanges: 'Guardar cambios',
        errors: {
          nameRequired: 'Indique el nombre del módulo.',
          waitUpload: 'Espere a que terminen las cargas de adjuntos para guardar los cambios.',
          pendingAttachments:
            'Hay adjuntos pendientes de subida. Vuelva a enviar los archivos antes de guardar.',
          saveBeforeInsert:
            'Guarde el módulo para completar la carga antes de insertar este adjunto en markdown.',
        },
      },
      delete: {
        title: 'Confirmar eliminación',
        message: '¿Desea eliminar realmente el módulo {{name}}?',
        cancel: 'Cancelar',
        confirm: 'Eliminar',
        deleting: 'Eliminando...',
      },
      category: {
        createTitle: 'Nueva categoría',
        createSubtitle: 'Cree una categoría para organizar los módulos.',
        editTitle: 'Editar categoría',
        editSubtitle:
          'Cambie el nombre y el prefijo de ruta usado en la URL de activación de los módulos de esta categoría.',
        name: 'Nombre de la categoría',
        pathPrefix: 'Prefijo de ruta (categoría)',
        pathHint:
          'Primer segmento de la URL de activación. Un único segmento, sin "/" ni espacios. Opcional.',
        pathHintEdit:
          'Déjelo vacío para eliminar el prefijo (el backend lo interpreta como eliminación).',
        pathPlaceholder: 'ej.: analytics',
        sectionName: 'Nombre de la sección (menú)',
        sectionPlaceholder: 'Ej.: Facial',
        svgIcon: 'Icono (SVG)',
        svgFilter: 'Filtrar por carpeta o archivo…',
        svgCatalogHint:
          'Catálogo en src/assets/svg. Se envía a la API en el campo svg como ./assets/media/svg/…',
        cancel: 'Cancelar',
        saving: 'Guardando...',
        create: 'Crear categoría',
        save: 'Guardar',
        errors: {
          nameRequired: 'Indique el nombre de la categoría.',
          invalidIcon: 'Seleccione un icono válido de la lista.',
          maxLength: '{{field}} puede tener como máximo 128 caracteres.',
          invalidSegment:
            '{{field}} debe ser un único segmento de URL (sin barra ni espacios en blanco).',
        },
      },
      activationHint:
        'La ruta de activación (prefijo de categoría + segmento del módulo) solo aparece cuando la categoría seleccionada tiene prefijo y el módulo tiene segmento de ruta.',
      markdownPlaceholder: 'Describa aquí la formación y el uso del módulo...',
    },
    analytics: {
      title: 'Catálogo de analíticos',
      newType: '+ Nuevo tipo',
      newAnalytic: '+ Nuevo analítico',
      loading: 'Cargando analíticos...',
      empty: 'No se encontraron analíticos.',
      count: '{{count}} analíticos',
      details: 'Detalles',
      noManufacturers: 'Sin fabricantes',
      coverage: '{{integrated}}/{{total}}',
      typeForm: {
        title: 'Nuevo tipo de analítico',
        subtitle: 'Registre una categoría para agrupar analíticos.',
        name: 'Nombre',
        code: 'Código',
        description: 'Descripción',
        cancel: 'Cancelar',
        saving: 'Guardando...',
        save: 'Guardar',
        errors: {
          required: 'Indique el nombre y el código del tipo de analítico.',
        },
      },
      analyticForm: {
        title: 'Nuevo analítico',
        subtitle: 'Complete los datos para añadir un nuevo analítico al catálogo.',
        code: 'Código',
        name: 'Nombre',
        category: 'Categoría',
        icon: 'Icono',
        shortDescription: 'Descripción breve',
        fullDescription: 'Detalles completos',
        useCases: 'Casos de uso',
        compatibleManufacturers: 'Fabricantes compatibles',
        select: 'Seleccione',
        cancel: 'Cancelar',
        saving: 'Guardando...',
        save: 'Guardar',
        errors: {
          required: 'Complete código, nombre y categoría.',
        },
      },
      detailsPanel: {
        title: 'Detalles del analítico',
        description: 'Descripción',
        noDescription: 'Sin descripción registrada.',
        useCases: 'Casos de uso',
        manufacturerCompatibility: 'Compatibilidad con fabricantes',
        yes: 'SÍ',
        no: 'NO',
      },
    },
    iconPicker: {
      noIcon: 'Sin icono',
    },
  },
  tickets: {
    title: 'Tickets',
    subtitle: 'Central de tickets de soporte de todos los clientes licenciados.',
    summaryAria: 'Resumen de tickets',
    operator: {
      title: 'Operador Conectado',
      loading: 'Cargando...',
      onlyMine: 'Mis tickets ({{count}})',
      all: 'Todos los operadores',
      hint: 'Selecciona una empresa en el filtro para listar todos los operadores registrados en ella.',
    },
    stats: {
      total: 'Total de Tickets',
      open: 'Abiertos',
      closed: 'Cerrados',
      highPriority: 'Alta Prioridad',
      unansweredToday: 'Sin respuesta hoy',
    },
    severity: {
      low: 'Baja',
      medium: 'Media',
      high: 'Alta',
    },
    priority: {
      low: 'Baja',
      medium: 'Media',
      high: 'Alta',
      urgent: 'Urgente',
    },
    export: 'Exportar',
    exportFilename: 'tickets',
    refresh: 'Actualizar',
    view: {
      compact: 'Vista compacta',
      list: 'Vista de lista',
      grid: 'Vista de cuadrícula',
    },
    searchPlaceholder: 'Buscar por título, descripción, ubicación o empresa...',
    filters: {
      search: 'Buscar',
      company: 'Empresa',
      status: 'Estado',
      type: 'Tipo',
      severity: 'Prioridad',
      from: 'Fecha inicial',
      to: 'Fecha final',
      clear: 'Limpiar filtros',
      allCompanies: 'Todas las empresas',
      allStatuses: 'Todos los estados',
      allTypes: 'Todos los tipos',
      allSeverities: 'Todas las prioridades',
    },
    tabs: {
      all: 'Todos',
      open: 'Abiertos',
      closed: 'Cerrados',
    },
    newButton: 'Nuevo Ticket',
    loading: 'Cargando tickets...',
    empty: 'No se encontraron tickets.',
    table: {
      title: 'Ticket',
      company: 'Empresa',
      location: 'Ubicación',
      type: 'Tipo',
      severity: 'Prioridad',
      status: 'Estado',
      createdAt: 'Creado el',
      updatedAt: 'Actualizado el',
    },
    detail: {
      close: 'Cerrar',
      status: 'Estado:',
      loadingConversation: 'Cargando conversación...',
      noMessages: 'Aún no hay mensajes.',
      replyPlaceholder: 'Escribe una respuesta...',
      send: 'Enviar',
      sending: 'Enviando...',
      attachment: 'Adjunto',
      slaDueAt: 'SLA hasta',
      assignee: 'Responsable',
      internalNote: 'Nota interna',
      markInternal: 'Marcar como nota interna (aún no visible para el cliente)',
      linkSolution: 'Vincular solución (opcional)',
      linkSolutionHint: 'Ayuda a medir la efectividad de las soluciones del catálogo.',
      noSolution: 'Sin solución vinculada',
    },
    form: {
      title: 'Nuevo Ticket',
      subtitle: 'Abre un ticket de soporte en nombre de un cliente licenciado.',
      sections: {
        company: 'Información de la Empresa',
        details: 'Detalles del Ticket',
      },
      company: 'Empresa',
      selectCompany: 'Selecciona la empresa',
      location: 'Ubicación',
      selectLocation: 'Selecciona la ubicación',
      loadingLocations: 'Cargando ubicaciones...',
      type: 'Tipo',
      status: 'Estado',
      severity: 'Prioridad',
      priority: 'Prioridad',
      assignee: 'Responsable (equipo Fisital)',
      unassigned: 'Sin responsable',
      titleField: 'Asunto',
      titlePlaceholder: 'Describe brevemente el problema',
      description: 'Descripción',
      descriptionPlaceholder: 'Detalles adicionales sobre el ticket...',
      attachments: 'Evidencia (capturas de pantalla)',
      cancel: 'Cancelar',
      saving: 'Guardando...',
      create: 'Crear ticket',
      errors: {
        required: 'Completa empresa, ubicación, tipo, estado, título y descripción.',
        attachmentsFailed: 'Ticket creado, pero el envío de los adjuntos falló: {{message}}',
      },
    },
  },
  knowledgeBase: {
    title: 'Base de Conocimiento',
    subtitle: 'Catálogo de problemas y soluciones alimentado por el historial de tickets.',
    searchPlaceholder: 'Buscar por nombre, módulo o producto...',
    newCategory: 'Nueva categoría',
    empty: 'Todavía no hay categorías de problema registradas.',
    occurrences: 'Ocurrencias',
    solutions: 'Soluciones',
    noSolutions: 'Todavía no hay soluciones registradas para esta categoría.',
    newSolution: 'Nueva solución',
    addSolution: 'Agregar solución',
    removeCategory: 'Eliminar categoría',
    activate: 'Reactivar',
    deactivate: 'Desactivar',
    loadError: 'No se pudo cargar la base de conocimiento.',
    confirmRemoveCategory: '¿Eliminar la categoría "{{name}}"? También se eliminan sus soluciones.',
    confirmRemoveSolution: '¿Eliminar la solución "{{title}}"?',
    severity: {
      low: 'Baja',
      medium: 'Media',
      high: 'Alta',
    },
    form: {
      name: 'Nombre del problema',
      module: 'Módulo',
      product: 'Producto',
      description: 'Descripción',
      solutionTitle: 'Título de la solución',
      tags: 'Etiquetas (separadas por coma)',
      steps: 'Pasos (uno por línea)',
    },
    table: {
      title: 'Solución',
      usage: 'Usos',
      effectiveness: 'Efectividad',
      avgTime: 'Tiempo medio',
    },
  },
};
